/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const NUMBER_OF_RESULTS = {
  DEFAULT: 3,
  MAX: 5,
  MIN: 1,
  SHOW_MORE_MAX: 10
};
export const ASSISTANT_NEW_VERSION = '2020-09-24';
export const CONFIDENCE_THRESHOLD_NUMBER = 0.2;
export const CONFIDENCE_THRESHOLD_NUMBER_DISABLED = 0.0;
export const MAX_CHAR = 140;
export const CONFIDENCE_THRESHOLD_VALUE = {
  RARELY: 'rarely',
  LESS_OFTEN: 'less_often',
  MORE_OFTEN: 'more_often',
  MOST_OFTEN: 'most_often'
};
export const RESPONSE_LENGTH_VALUE = {
  CONCISE: 'concise',
  MODERATE: 'moderate',
  VERBOSE: 'verbose'
};
